import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Message from '../../../common2/Message';

import './ClaimStepClosableMessage.scss';

function ClaimStepClosableMessage({ children, intent }) {
  const [showMessage, setShowMessage] = useState(true);

  const element = (
    <div styleName="banner">
      <Message intent={intent} onClick={() => setShowMessage(!showMessage)}>
        {children}
      </Message>
    </div>
  );

  return showMessage && element;
}

ClaimStepClosableMessage.propTypes = {
  children: PropTypes.any,
  intent: PropTypes.string,
};

export default ClaimStepClosableMessage;
